/*
 * Validate beforeFullNowEmpty
 */
 $.formUtils.addValidator({
     name : 'beforeFullNowEmpty',
     validatorFunction : function(val, $el) {
    	 let prevVal = $el.data('prev-val');
         if( val.length == 0 && prevVal != undefined && prevVal.length > 0) {
             return false;
         } else {
        	 return true;
         }
     },
     errorMessage : '',
     errorMessageKey : 'badBeforeFullNowEmpty'
 });
